export async function getCaptchaToken(_opts: {
  action: string;
}): Promise<string | undefined> {
  // stub
  return undefined;
}
